import React from 'react'

import { Navigate } from '@lib/react-router-dom'

import { getNextSignupRoute } from '@pages/Signup/routes/getNextSignupRoute'

import { useAccountReadContext } from '@context/AccountContextContext'

export const FirstTimeDepositOrDocumentsResolver: React.FC = () => {
  const { account } = useAccountReadContext()

  const nextRoute = getNextSignupRoute(account)

  return <Navigate to={nextRoute} replace />
}
